import { useQuery } from '@tanstack/react-query';
import type { TemplateConfig } from '@brighterion/types/config';
import { RQ_TEMPLATE_CONFIG } from 'Utils';
import { getTemplateConfig } from 'Services';

const useTemplateConfig = () => {
    return useQuery<TemplateConfig>([RQ_TEMPLATE_CONFIG], getTemplateConfig);
};

export default useTemplateConfig;
